import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const QuerySwitch: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleSilentCall = async () => {
      const action = searchParams.get("action");
      const tenant = searchParams.get("tenant");
      const key = searchParams.get("key");

      const params = {
        status: action,
        key: key,
      };

      try {
        await axios.post("/snotes/api/querySwitch", params, {
          headers: {
            "X-TENANT-ID": tenant,
          },
        });
      } catch (error) {
      } finally {
        setTimeout(() => {
          window.close();
        }, 500);
      }
    };

    handleSilentCall();
  }, [searchParams]);

  return null;
};

export default QuerySwitch;
